import styled from 'styled-components';

export const InfoWrapper = styled.div`
    margin-bottom: 24px;
`;

interface InputsWrapperProps {
    columns: number;
}

export const InputsWrapper = styled.div<InputsWrapperProps>`
    display: grid;
    grid-template-columns: ${({columns}) => columns === 4 ? '160px 140px 160px 220px' : '160px 140px auto'};
    gap: 24px;
`;
